<script>
export default {
  name: "Home",
  created(){
      window.location.href = "https://nearguide.dev.weblevel.pt/admin";
  }

};
</script>